import { render, staticRenderFns } from "./DeleteCourse.vue?vue&type=template&id=1afc60b6&"
import script from "./DeleteCourse.vue?vue&type=script&lang=js&"
export * from "./DeleteCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports